<template>
  <div>
    <div id="page" data-swup="0" class="device-is-android">
      <header-bar title="Салбар Зөвлөл"></header-bar>

      <footer-bar></footer-bar>
      <div
        class="page-content header-clear-medium has-footer-menu"
        style="transform: translateX(0px)"
      >
        <div class="card card-style">
          <div class="content mb-0">
            <!-- {{tasks.length}} {{ $route.params.id }} -->
            <template v-for="task in tasks">
              <router-link
                :to="getLink(task)"
                :key="task.id"
              >
                <div class="d-flex mb-3">
                  <div>
                    <img
                      :src="`${task.defaultAttachmentUrl}?h=70&w=70&mode=crop`"
                      width="70"
                      class="rounded-sm"
                    />
                  </div>
                  <div>
                    <p class="ps-3 line-height-s color-theme mb-1">
                      {{ task.task }}
                    </p>
                  </div>
                </div>
              </router-link>
              <div class="divider mb-3"></div>

              <!-- <div
              class="d-flex mb-3"
              @click="handleDetailModal({ show: true, id: task.id })"
            >
              <div>
                <a
                  ><img
                    :src="`${task.defaultAttachmentUrl}?h=70&w=70&mode=crop`"
                    width="70"
                    class="rounded-sm"
                /></a>
              </div>
              <div>
                <a>
                  <p class="ps-3 line-height-s color-theme mb-1">
                    {{ task.task }}
                  </p>
                </a>
              </div>
            </div>
            <div class="divider mb-3"></div> -->
            </template>
          </div>
        </div>
      </div>

      <div class="page-bg">
        <div></div>
      </div>

      <div class="divider divider-margins"></div>
    </div>
  </div>
</template>

<script>
import { request } from "@/api/all";
import { mapActions } from "vuex";
import footerBar from "@/views/apps/ubtzyouth/footerBar";
import headerBar from "@/views/apps/ubtzyouth/headerBar";
export default {
  components: {
    footerBar,
    headerBar,
  },
  data() {
    return {
      tasks: [],
    };
  },
  methods: {
    ...mapActions(["handleDetailModal"]),
    getLink(task){
      if(task.locTypeId2!=null)
        return `/w/medeelel/${task.locTypeId2}`;
      else
        return `/w/medeelel/${task.locTypeId1}`;
    }
  },
  mounted() {
    // this.tasks = _.sortBy(
    //   this.$store.state.app.pages.filter(
    //     (x) => x.parentId == this.$route.params.id && x.i2 == 1
    //   ),
    //   "ord",
    //   "asc"
    // );
    request({
      api: { method: "POST", url: "taskCore/getCoreList" },
      data: {
        skip: 0,
        size: 1000,
        ot: 356,
        model: {
          isPublic: true,
          locTypeId1: this.$route.params.id,
        },
      },
      store: this.$store,
    }).then((res) => {
      this.tasks = _.sortBy(
        res.data.tasks.filter(
          (x) => x.locTypeId1 == this.$route.params.id && x.id != 3347898
        ),
        "ord",
        "asc"
      );
    });
    // request({
    //   api: { method: "POST", url: "taskCore/getCoreList" },
    //   data: {
    //     skip: 0,
    //     size: 10,
    //     ot: 357,
    //     model: {
    //       isPublic: true,
    //       locTypeId1: 153362,
    //     },
    //   },
    //   store: this.$store,
    // }).then((res) => {
    //   this.tasks = _.sortBy(res.data.tasks, "ord", "asc");
    // });
  },
};
</script>
